import { render, staticRenderFns } from "./VeJwChengjiModal.vue?vue&type=template&id=c920e37a"
import script from "./VeJwChengjiModal.vue?vue&type=script&lang=js"
export * from "./VeJwChengjiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports